import React, { useState } from "react";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../gComponents/gButton";

export default function TagForm(props) {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [openSnackbar] = useSnackbar();

  const initialValues = {
    type: props.type ? props.type : "",
    title: !props.isEmpty ? props.data.title : "",
  };

  const onSubmit = (values) => {
    setIsBtnDisabled(true);
    console.log(values);

    var hitMethod = !props.isEmpty ? "PUT" : "POST";
    var hitUrl = !props.isEmpty ? "tags/" + props.data.id : "tags";
    ApiService({ method: hitMethod, route: hitUrl, body: values }).then(
      (response) => {
        console.log("r" + response.status_code);
        if (response.data.status_code === 1) {
          props.setTagvisible(false);
          props.onSubmit(response.data.data);
        }
        setIsBtnDisabled(false);
        openSnackbar(response.data.message);
        return;
      }
    );
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
  });

  if (props.tagvisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header">
        {!props.isEmpty ? "Edit" : "Add a"} Tag
      </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form>
            <FormikControl
              control="input"
              type="text"
              label="Title"
              name="title"
              rows="4"
            />
            <GButton
              type="submit"
              disabled={isBtnDisabled}
              variant="condensed"
              children={!props.isEmpty ? "Update" : "Create"}
              style={{ margin: "15px", width: "calc(100% - 30px)" }}
            />
          </Form>
        </Formik>
      </div>
    </>
  );
}
